<template>




  <div class=" grid">

    <loading
    :active="isLoadingModel"
    :can-cancel="true"
    @click ="openNew"
    color="#803BB9"
    :is-full-page="fullPage"
  ></loading>

    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
          <template #item="{ item, props }">
            <router-link
              v-if="item.to"
              v-slot="{ href, navigate }"
              :to="item.to"
              custom
            >
              <a :href="href" @click="navigate">
                <span :class="[item.icon, 'text-color']" />
                <span class="text-primary font-semibold">{{ item.label }}</span>
              </a>
            </router-link>
          </template>
        </Breadcrumb>
        <Toast />
       
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <!-- <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="selectstatus">
              </InputText>
              <label for="m_no">status</label>
            </span>
          </div> -->
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="image_name">
              </InputText>
              <label for="m_no">Search</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown id="status" v-model="selectstatus" :options="status_dropdown" :value="status_dropdown"
                optionLabel="name" filter></Dropdown>
              <label for="status">Status</label>
            </span>
          </div>






          <!-- <div class="field col-12 md:col-2">
                        <Button style="background-color: #349CE4; border: 1px solid #349CE4;" icon="pi pi-search"
                            v-tooltip.bottom="'Search'" />
                    </div> -->
          <div class="field col-12 md:col-2">
            <Button  icon="pi pi-search" @click="search()"
              v-tooltip.bottom="'Search'"></Button>&nbsp;&nbsp;
            <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
          </div>
        </div>




        <DataTable 
        :loading="loading" 
        ref="dt"
        :lazy="true"
   
        :paginator="true" 
        showGridlines :rowHover="true" 
         :value="Batch"
        :totalRecords="totalRecords"
        :filters="filters"
          @page="onPage($event)" 
          size="small" 
          :rows="limit" 
          v-model:selection="selectedProducts" 
          :dataKey="columns[0]" 
          style="font-size: 12px" 
          :rowsPerPageOptions="paginationarray"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" 
          responsiveLayout="scroll"
         
         
          >
          <template #empty>
            <b style="text-align:center">No records found.</b>
          </template>
          <template #header>
            <!-- <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0"><b>Banner List</b></h5>
                  <Button icon="pi pi-refresh"   ></Button>
         
               
            </div> -->
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0"><b>Banner List </b></h5>
              <div>
                <Button icon="pi pi-plus" v-tooltip.bottom="'Add'" @click="openNew()" class="mr-2" />


                <br>
                <p>Total : {{ totalRecords }}</p>
              </div>
            </div>

          </template>



          <Column header="Sr.No" style="min-width: 5rem;text-align: center;">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ (+index + 1) + limit * (page_no - 1) }}</span>
            </template>

          </Column>

          <!-- <Column header="Status" style="min-width: 10rem;text-align: center;" :field="columns[1]">


          </Column> -->
          <Column header="Status" style="min-width: 3rem" :field="columns[0]">
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'">
                <badge :value=data.status severity="success"></badge>
              </span>
              <span v-else-if="data.status == 'InActive' || data.status == 'Inactive'">
                <badge :value=data.status severity="warning"></badge>
              </span>
              <span v-else-if="data.status == 'Deleted' || data.status == 'deleted'">
                <badge :value=data.status severity="danger"></badge>
              </span>
              <span v-else>-</span>
            </template>
          </Column>


          <Column header="Image Name" style="min-width: 10rem;text-align: center;" :field="columns[2]">

          </Column>

          <Column header="image Description " style="min-width: 15rem;text-align: center;" :field="columns[3]">

          </Column>

          <Column header="Photo" style="min-width: 5rem;text-align: " :field="columns[4]">
            <template #body="{ data }">
              <img :src="data.image_url" alt="" style="height: 25px;width: 25px;">
            </template>

          </Column>

          <Column header="Edit" headerStyle="min-width:15rem;">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning
              mr-2" @click="Edit(slotProps.data)" />
              <Button    icon="pi pi-trash" class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeletesBanner(slotProps.data)" />
            </template>
          </Column>
          


        </DataTable>


        <Dialog v-model:visible="productDialog" :style="{ width: '450px', width: '450px' }" 
          :modal="true" class="p-fluid"  @hide="onHide()">
          <div class="grid">
            <div class="col-12 md:col-12">
              <div class="field">
                <h5 v-if="product.image_id">Edit Banner</h5>
                            <h5 v-else>Add Banner</h5>
                            <hr />

              </div>
              <div class="field" v-if="product.image_id">
               <!-- <label for="batch">status</label>
               <InputText id="batch" v-model.trim="product.status" required="true" autofocus
                  :class="{ 'p-invalid': submitted && !product.batch }" />  -->
                  <!-- <label for="status">Status</label>
                  <Dropdown id="status" v-model="selectstatus" :options="status_dropdown" :value="status_dropdown"
                optionLabel="name" filter></Dropdown>  -->
             
             
               
                <label for="batch">Select Status</label>

                <Dropdown
                  id="batch"
                v-model="status" 
                  :options="status_dropdown"
                  :value="status_dropdown"
                  
                  optionLabel="name"
                 
                :class="{ 'p-invalid': submitted && !product.batch }" 
                  required="true"
                ></Dropdown>
               
              </div> 

              
              <div class="field">
                <label for="batch">Banner Name</label>
                <InputText id="batch" v-model.trim="product.image_name" required="true" autofocus
                  :class="{ 'p-invalid': submitted && !product.batch }" />
              </div>
              <div class="field">

                <label for="image_description">Banner Description</label>
                <!-- <InputText id="image_description" class="label-gap" v-model="product.image_description" /> -->
                <Textarea :autoResize="true" rows="3" cols="30" v-model.trim="product.image_description" />


              </div>
              <div class="field">
                <Button style="box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                 border-color: #00b0b0 !important;
                 background-color: #00b0b0 !important;" label="Upload Image" @click="toggleShow" icon="pi pi-check"
                  class="p-button" />
                <my-upload field="img" @crop-success="cropSuccess" langType="en" v-model="show_image" :width="width"
                  :height="height" :url="url" :params="params" :headers="headers" img-format="png" :noCircle="true"
                  :noRotate="false">
                </my-upload>






                <div class="field col-12 md:col-2" style="margin-top: 5%;">
                  <Image v-if="image_url" :src="image_url" alt="Image" width="150" preview />
                </div>

              </div>






            </div>
            <div class="col-12 md:col-6">
              <Button v-if="product.image_id" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                @click="EditBanner" />
              <Button v-else label="ADD" icon="pi pi-check" class="p-button-success mr-1 mb-1" @click="Addbanner" />

            </div>
            <div class="col-12 md:col-6">
              <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                @click="productDialog = false;" />
            </div>
          </div>
        </Dialog>
        <Dialog v-model:visible="deleteBannerDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete <b>{{ product.image_name }}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteBannerDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteBanner" />
          </template>
        </Dialog>


      </div>
    </div>
  </div>
</template>

<script>

import apis from "@/apis";
import BreadcrumbService from "../service/BreadcrumbService";

import ProductService from "../service/ProductService";
import myUpload from "vue-image-crop-upload";
// import JsonExcel from "vue-json-excel";
import axios from "axios";



export default {
  data() {
    return {
      Batch: null,
      show_image: false,
      page_no: 1,
      columns: [],
      now: "",
      file_attachment: "",
      deleteBannerDialog: false,
      productDialog: false,
      submitted: false,
      loading: false,
      product: {},
      filters: {},
      selectstatus: null,
      totalRecords: 0,
      ProductService: null,
      isLoadingModel: false,
      limit: 10,
      lazyParams: {},
      selectedProducts: null,
      show: false,
      status: "",
      paginationarray:[5, 10, 25], 
      status_dropdown: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      id: "",
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],

      fullPage: true,
      width: 1956,
      height: 500,
      image_url: "",
      Image_data: {
        filePath: "",
        contentType: "",
      },
      params: {
        token: "123456798",
        name: "avatar",
      },
      headers: {
        smail: "*_~",
      },
      image_url: "",
      url: "",
      image_name: "",


    }
  },
  async created() {
    this.productService = new ProductService();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
     "Banner", "/bannermaster" );
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
  },


  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.Batch = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },

  methods: {

    openNew() {
      this.product = {};
      this.submitted = false;
      this.imgDataUrl = "";
      this.productDialog = true;
      this.Image_data = {
        filePath: "",
        contentType: "",
      };
      // this.Image_data = {
      //   filePath:
      //     "Banner/" +
      //     filename,
      //   contentType: contentType,
      // };
     
      
    },
    onHide() {
      this.product = {};
     
  

      this.productDialog = false;
    },
    reset() {
      this.status = "";
      this.image_name = "";
      this.selectstatus = "";
     
       this.get_list();
      this.get_count();

      this.show = false;
    },
    confirmDeletesBanner(product) {
      this.product = product;
      if (this.product.status == 'Active') {
        this.deleteBannerDialog = true;
      } else {
        this.$swal("Already Deleted");
      }


    },
    confirmDeletescheme(product) {
      this.product = product;
      if (this.product.status == 'Active') {
        this.deleteschemeDialog = true;
      } else {
        this.$swal("Already Deleted");
      }


    },
    deletebanner() {
      this.product = this.product.filter((val) => val.id !== this.product.id);
      this.deleteBannerDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Banner Deleted",
        life: 3000,
      });
    },

    deleteBanner() {

      var data = {
        image_id: this.product.image_id,
      };
      this.isLoadingModel = true;
      var promise = apis.BannerDelete(data);
      promise.then((responseapi) => {
        this.isLoadingModel = false;
        if (responseapi.status == 200) {

        
          this.deleteBannerDialog = false;
          this.$swal(responseapi.data.message);
          this.get_list();
          this.get_count();
        } else {
          this.$swal("error to Delete Scheme");
        }
      });
    },

    toggleShow() {
      this.show_image = !this.show_image;
      
    },
    isImage(url) {
      return /\.(jpeg|jpg|gif|png)$/i.test(url);
    },
    async cropSuccess(image_url) {
      this.image_url = image_url;
      var substrings = image_url.split(";");
      var contentType = substrings[0].split(":");
      var type = image_url.split(";")[0].split("/")[1];
      this.handleFileUpload_thumb_with_cropper(image_url, type, contentType[0]);
    },
    async handleFileUpload_thumb_with_cropper(image_url, type, contentType) {
      var prfeix = await this.generateString();
      var filename = "banner_" + prfeix + "." + type;
      var subimage_url = image_url.split(",");
      var file = await this.handleFileChange(
        subimage_url[1],
        contentType,
        filename
      );
      this.Image_data = {
        filePath: "",
        contentType: "",
      };
      this.Image_data = {
        filePath:
          "Banner/" +
          filename,
        contentType: contentType,
      };
      this.isLoadingModel = true;
      var promise = apis.upload_to_AWS(this.Image_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": contentType,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;

          });
      });
    },
    async generateString() 
        {
            // Get the current date and time
            const currentDateTime = new Date();
            // Format the date as YYYY_MM_DD
            const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');
            // Format the time as HH_mm_ss
            const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');
            // Construct the final string
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
    async handleFileUpload(event) {
      var fileUp = event.files[0];
      if (fileUp) {
        this.previewImage = URL.createObjectURL(fileUp);
      }
      var file = fileUp;
      this.file = file;
      var prfeix = await this.date_time_prefix();
      var filename = prfeix + "_" + file.name.replace(/\s+/g, "_");
      this.file_data = {
        filePath: 'Banner/' + filename,
        contentType: file.type,
      };
      this.isLoadingModel = true;
      var promise = apis.upload_to_AWS(this.file_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;

            this.attachments_image = "https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/Banner/banner.jpg" + filename;
            console.log(this.attachments_image);
          });
      });
    },
    async handleFileChange(base64, content_Type, filename) 
        {
            const base64String = base64;
            const contentType = content_Type;
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) 
            {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: contentType });
            const fileName = filename;
            var file = new File([blob], fileName, { type: contentType });
            return file;
        },
    async date_time_prefix() {
      const currentDateTime = new Date();
      const formattedDate = currentDateTime
        .toISOString()
        .split("T")[0]
        .replace(/-/g, "_");
      const formattedTime = currentDateTime
        .toTimeString()
        .split(" ")[0]
        .replace(/:/g, "_");
      const resultString = `${formattedDate}_${formattedTime}`;
      return resultString;
    },
    onHide() {
      this.image_name = null;
      this.image_description = null;
      this.image_url = null;

      this.productDialog = false;

    },
    async search(count) {
      if (count == 2) {
        this.status = '';
        this.selectstatus = '';

        this.image_name = '';

      }
      await this.get_list();
      await this.get_count();
    },
    async Addbanner() {
      this.submitted = true;
      // if (!this.product.image_name) {
      //   this.$toast.add({
      //     severity: "error",
      //     summary: "error",
      //     detail: "Please Enter image name",
      //     life: 3000,
      //   });
      //   return false;
      // }
      if (!this.product.image_name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter image name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.image_description) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Image Description",
          life: 3000,
        });
        return false;
      }


      

      if (!this.Image_data.filePath) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "please upload Image",
          life: 3000,
        });
        return false;
      }



      var data = {

        image_name: this.product.image_name,
        image_description: this.product.image_description,
        image_url: "https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/"+this.Image_data.filePath,


        created_By: this.created_By,

      };


      this.isLoadingModel = true;
      var promise = apis.AddBanner(data);
      promise
        .then((responseapi) => {
          this.$swal(responseapi.data.message);
          this.isLoadingModel = false;
          this.productDialog = false;
          this.get_list();
          this.get_count();
        })
        .catch((error) => {
          //console.log(error);
          this.isLoadingModel = false;
          this.productDialog = false;
        

          this.$swal.fire(error.response.data);
          this.get_list();
          this.get_count();

        });

      this.selectstatus = { name: "", value: "" }

    },
    EditBanner() {
      this.submitted = true;
      if (!this.product.image_name) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Image name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.status) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter status",
          life: 3000,
        });
        return false;
      }
      // alert(this.Image_data.filePath);
      if (!this.product.image_url && this.Image_data.filePath=='') {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Upload Image",
          life: 3000,
        });
        return false;
      }
      var image_url=this.product.image_url;
      if(this.Image_data.filePath != "")
      {
        image_url="https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/"+this.Image_data.filePath 

      }
      var data1 =
      {
        image_id: this.product.image_id,
        image_name: this.product.image_name,
        image_url :image_url,
        updated_by: localStorage.getItem("id"),
        image_description: this.product.image_description,
        status:this.status.value

      };
      this.isLoadingModel = true;
      var promises = apis.EditBanner(data1);
      promises
        .then((responseapi) => {

          this.isLoadingModel = false;
          this.productDialog = false;
          this.$swal(responseapi.data.message);
          this.get_list();
          this.get_count();
        })
        .catch((error) => {
          //console.log(error);
          this.isLoadingModel = false;
          this.productDialog = false;

          this.$swal.fire(error.response.data);
          this.get_list();
          this.get_count();
        });


      this.selectstatus = { name: "", value: "" }

    },
    Edit(product) {
      // this.file_attachment = "";
      this.selectstatus = "";
      //this.product.status = {name:this.product.status_dropdown,value:this.product.status_dropdown}
      this.product = { ...product };
      this.productDialog = true;
      this.attachments_image = this.product.image_name;
      this.image_url =  this.product.image_url;
       this.status = {name: this.product.status,value:this.product.status};
       this.Image_data = {
        filePath: "",
        contentType: "",
      };
      // this.Image_data = {
      //   filePath:
      //     "Banner/" +
      //     filename,
      //   contentType: contentType,
      // };
        // alert(this.status)
      // this.selectstatus={name:this.product.status,value:this.product.status}
      // if (this.product.from_date) 
      // {
      //   this.product.from_date = new Date(this.product.from_date);
      // }
      // if (this.product.till_date) {
      //   this.product.till_date = new Date(this.product.till_date);
      // }


      console.log(this.image_name);

    },



    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];

      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }

    },

    get_count: function () {
       var status = '';
      if (this.selectstatus) {
        status = this.selectstatus.value;
      }
      var data = {
        count: true,
        status: status,
        // image_name: this.image_name,
        image_name: this.image_name,
      };
      this.loading = true;
      var promise = apis.bannerlist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        // console.log(response);
        this.totalRecords = response.data.total;
        this.paginationarray=[5, 10, 25];
        if(this.totalRecords > 25 )
        {
          this.paginationarray.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });

      console.log(data);
    },
    get_list: function () {
      var status = '';
      if (this.selectstatus) {
        status = this.selectstatus.value;
      }
      // console.log(status);
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
       
        status: status,
        image_name: this.image_name,
        
      };
      this.loading = true;
      var promise = apis.bannerlist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.Batch = response.data.data;
        console.log(23);
        console.log(this.Batch[0]);
        if (this.columns.length == 0) {
          if (this.Batch.length > 0) {
            this.columns = Object.keys(this.Batch[0]);
          }
        }
      });
    },
  },



  components: { "my-upload": myUpload },


};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>